import { DocumentService } from 'src/services/document.service';
import { Component, ViewChild } from '@angular/core';
import { AlertController, IonFab, LoadingController, ModalController, Platform, ToastController, IonSlides } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import QRCode from 'qrcode';
import { PacientService } from 'src/services/pacient.service';
import { AuthenticateService } from '../../../services/authenticate.service';
import { Util } from '../../../util/util';
import { ModalVacinaErrorComponent } from '../modal-vacina-error/modal-vacina-error-component';

@Component({
  selector: 'modal-cartao-covid',
  templateUrl: 'modal-cartao-covid-component.html',
  styleUrls: ['modal-cartao-covid-component.scss']
})

export class ModalCartaoCovidComponent {
  @ViewChild('slider') slider: IonSlides;
  @ViewChild('fabBottom') fabBottom: IonFab;
  tipo: any;
  qrcode: any = {};
  language = 'pt';
  padrao = 'br';
  type = 'cartao';
  code: any;
  id: any;
  data: any = {};
  doses: any = [];
  estabelecimentoUnico: any = {};
  url = {};
  cardAntigo: any;
  cardValido: any;
  userInfo: any = {};
  months = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  slideOpts = {
    initialSlide: 0
  };

  slidIndex: any;

  constructor(private toastController: ToastController,
    private modalController: ModalController,
    private loadingCtrl: LoadingController,
    private paciente: PacientService,
    private auth: AuthenticateService,
    // private storage: Storage,
    private alertController: AlertController,
    private translate: TranslateService,
    private document: DocumentService) {

  }

  async slidesChange() {
    this.slider.getActiveIndex().then(async index => {
      this.slidIndex = index;
    });
  }

  async proximo() {
    await this.slider.slideNext();
  }

  async anterior() {
    await this.slider.slidePrev();
  }

  ionViewDidEnter() {
    this.language = localStorage.getItem('LANGUAGE');
    this.padrao = localStorage.getItem('PADRAO');
    if (!this.language || !this.padrao) {
      localStorage.setItem('LANGUAGE', 'pt');
      localStorage.setItem('PADRAO', 'br');
      this.language = 'pt';
      this.padrao = 'br';
    }
    this.translate.setDefaultLang(this.language);
    this.loadData();
  }

  verCartao(tipo) {
    this.type = tipo;
  }

  fechar() {
    this.modalController.dismiss();
  }

  async idiomaSelected(value) {
    this.language = value;
    localStorage.setItem('LANGUAGE', this.language);
    this.loadData();
  }

  async padraoSelected(value) {
    this.padrao = value;
    this.loadData();
  }


  async download() {
    const loading = await this.loadingCtrl.create();
    await loading.present();
    const valid = await this.auth.verifyTokenValido();
    if (valid === false) {
      await loading.dismiss();
      await this.errorLogin();
    }

    await this.document.downloadVacina();
    // await this.paciente.getPdfCertificadoCovid(this.data.codigo, this.language);
    await loading.dismiss();
  }

  async alertError(err) {
    const alert = await this.alertController.create({
      header: 'Alerta!',
      message: err,
      buttons: [
        {
          text: 'Fechar',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  async loadData() {
    const loading = await this.loadingCtrl.create();
    await loading.present();
    let userInfo = this.auth.getUserData();
    this.cardAntigo = null; //await this.storage.get('_cartao_vacina_on' + userInfo.cns);

    await this.validaCartao();

    if (!this.cardAntigo || !this.cardValido) {
      let result;
      if (this.padrao == 'ue') {
        result = await this.paciente.getDadosCertificadoCovidUk();
      } else {
        result = await this.paciente.getDadosCertificadoCovid();
      }

      if (!result.esquemaDoseCompleto) {
        await loading.dismiss();
        const exterior = result.vacinas.find((vacina) => (vacina.registroOrigem === '02'));
        await this.vacinaError(exterior);
        return;
      }

      // this.storage.set('_cartao_vacina_on' + userInfo.cns, this.data);
      if (result.error && result.error.message) {
        await loading.dismiss();
        this.modalController.dismiss();
        this.alertError(result.error.message);
        return;
      }
      this.data = result;
      if (!this.data) {
        await loading.dismiss();
        return this.notData();
      }

      if (this.data.error) {
        await loading.dismiss();
        return;
      }
    } else {
      this.data = this.cardAntigo;
    }

    this.data.paciente.cpf = await Util.formatarCpf(this.data.paciente.cpf);
    this.estabelecimentoUnico = this.data.estabelecimentosUnico;

    this.userInfo = this.data.paciente;

    this.doses = this.data.vacinas;
    this.doses.forEach(d => {
      if (this.estabelecimentoUnico && this.estabelecimentoUnico.length > 0) {
        let estab = this.estabelecimentoUnico.find(e => {
          if (e.cnes) {
            if (!d.estabelecimento.cnes) {
              return d.estabelecimento.includes(e.cnes);
            }
          }
        });
        if (estab) {
          d.estabelecimento = estab;
        }
      }
    });

    QRCode.toDataURL(this.data.signToken, { errorCorrectionLevel: 'H' }, (err, url) => {
      this.qrcode.image = url;
    });

    this.qrcode.codigo = await Util.formatarCodCertificado(this.data.codigo);

    await loading.dismiss();
  }

  async validaCartao() {
    if (this.cardAntigo) {
      const item: any = await this.paciente.read(this.cardAntigo.signToken);
      this.cardValido = item.situacao === 'V';
    }
  }

  async vacinaError(exterior) {
    await this.fechar();

    const modal = await this.modalController.create({
      component: ModalVacinaErrorComponent,
      keyboardClose: true,
      cssClass: 'modal-fab-bottom',
      componentProps: {
        exterior,
      }
    });
    await modal.present();
  }

  async notData() {
    const toast = await this.toastController.create({
      cssClass: 'modal-toast',
      message: 'Você não possui vacinas para gerar o certificado',
      position: 'top',
      duration: 4000
    });
    this.modalController.dismiss();
    await toast.present();
  }

  async errorLogin() {
    const toast = await this.toastController.create({
      cssClass: 'modal-toast toast-error',
      message: 'Realize o acesso para gerar o certificado',
      position: 'top',
      duration: 4000
    });
    this.modalController.dismiss();
    await toast.present();
  }

  formatDate(data) {
    let date = data;
    if (data) {
      if (this.language == 'en') {
        date = data.split('T');
        date = date[0].split('-');
        date = date[2] + '.' + this.months[parseInt(date[1])] + '.' + date[0];
      } else {
        date = data.split('T');
        date = date[0].split('-');
        date = date[2] + '/' + date[1] + '/' + date[0];
      }
    }
    return date;
  }

  async clearReload() {
    let userInfo = this.auth.getUserData();
    // await this.storage.remove('_cartao_vacina_on' + userInfo.cns);
    this.loadData();
  }

  async errorGerar() {
    const toast = await this.toastController.create({
      cssClass: 'modal-toast toast-error',
      message: 'Ocorreu um erro ao gerar a carteira',
      position: 'top',
      duration: 4000
    });
    await toast.present();
  }
}
